import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import classnames from 'classnames';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/CancelOutlined';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import moment from 'moment'
import 'moment-timezone';
import 'react-trumbowyg/dist/trumbowyg.min.css'
import Trumbowyg from 'react-trumbowyg'
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {observer} from "mobx-react";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';

const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
    rightIcon: {
        marginLeft: theme.spacing.unit,
    },
    iconSmall: {
        fontSize: 20,
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200
    },
    warningButton: {
        margin: theme.spacing.unit,
        color: "white",
        backgroundColor: "#E9190F",
        '&:hover': {
            backgroundColor: "#E9190F",
        },
    },
    appBar: {
        backgroundColor: 'white',
        top: 'auto',
        bottom: 0,
    }
});

class TermsDetails extends Component
{

    constructor(props)
    {
        super(props);

        this.state = {
            deleteModal: false,
            safetyCheckWord: '',
            safetyCheckPassed: false
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSafetyCheckInputChange = this.handleSafetyCheckInputChange.bind(this);
        this.handleDeHTMLEditorBlur = this.handleDeHTMLEditorBlur.bind(this);
        this.handleEnHTMLEditorBlur = this.handleEnHTMLEditorBlur.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    toggleModal()
    {
        this.setState({
            deleteModal: !this.state.deleteModal,
        });
    }

    handleInputChange(event)
    {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.props.termsStore.terms[name] = value;
    }

    handleDeHTMLEditorBlur = (value) =>
    {
        this.props.termsStore.terms.terms_de = value.target.innerHTML;
    };

    handleEnHTMLEditorBlur = (value) =>
    {
        this.props.termsStore.terms.terms_en = value.target.innerHTML;
    };

    handleSafetyCheckInputChange(event)
    {
        const target = event.target;
        const value = target.value;
        this.setState({safetyCheckWord: value})
        if (value === this.props.termsStore.terms.uuid)
        {
            this.setState({safetyCheckPassed: true})
        } else
        {
            this.setState({safetyCheckPassed: false})
        }
    }

    deleteTerms()
    {
        this.props.termsStore.deleteTerms(this.props.match.params.id);
    }

    handleSubmit(event)
    {
        this.props.termsStore.saveTerms(this.props.match.params.id);
        event.preventDefault();
    }

    componentDidMount()
    {
        this.props.termsStore.getTerms(this.props.match.params.id);
    }

    render()
    {
        const {classes} = this.props;

        return (
            <div>
                <ToastContainer/>
                <Dialog
                    open={this.state.deleteModal}
                    onClose={this.toggleModal}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">AGB &amp; Datenschutz löschen</DialogTitle>
                    <DialogContent>
                        Um die Nutzungsbedingungen endgültig zu löschen, bestätige den Vorgang durch Eingabe der
                        ID <strong>{this.props.termsStore.terms.uuid}</strong>.
                        <br/>
                        <TextField
                            id="uuid"
                            name="uuid"
                            label="ID"
                            value={this.state.safetyCheckWord}
                            onChange={this.handleSafetyCheckInputChange}
                            margin="normal"
                            InputLabelProps={{shrink: true}}
                            fullWidth={true}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" size="small" color="primary" onClick={this.toggleModal} className={classes.button}>
                            <CancelIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                            Abbrechen
                        </Button>
                        <Button variant="contained" size="small" color="secondary" onClick={() => this.deleteTerms()} className={classes.warningButton}
                                disabled={!this.state.safetyCheckPassed}>
                            <DeleteIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                            Löschen
                        </Button>
                    </DialogActions>
                </Dialog>
                <Typography variant="title" gutterBottom>
                    Nutzungsbedingungen (AGB & Datenschutz)
                </Typography>
                <form noValidate autoComplete="off">
                    <Grid container spacing={16} style={{marginBottom: 30}}>
                        <Grid item>
                            <TextField
                                id="uuid"
                                name="uuid"
                                label="ID"
                                className={classes.textField}
                                value={this.props.termsStore.terms.uuid || ''}
                                onChange={this.handleInputChange}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                disabled
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="active"
                                name="active"
                                select
                                label="Aktiv"
                                className={classes.textField}
                                value={this.props.termsStore.terms.active || 0}
                                onChange={this.handleInputChange}
                                SelectProps={{
                                    native: true,
                                    MenuProps: {
                                        className: classes.menu,
                                    },
                                }}
                                margin="normal"
                                InputLabelProps={{shrink: true}}>
                                <option value="1">Ja</option>
                                <option value="0">Nein</option>
                            </TextField>
                        </Grid>
                        <Grid item>
                            <TextField
                                id="note"
                                name="note"
                                label="Anmerkung"
                                className={classes.textField}
                                value={this.props.termsStore.terms.note || ''}
                                onChange={this.handleInputChange}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="created"
                                name="created"
                                label="Erstellt am"
                                className={classes.textField}
                                value={this.props.termsStore.terms.created ? moment(this.props.termsStore.terms.created).format("DD.MM.YYYY / HH:mm") : 'Nie'}
                                onChange={this.handleInputChange}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                disabled
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="updated"
                                name="updated"
                                label="Bearbeitet am"
                                className={classes.textField}
                                value={this.props.termsStore.terms.updated ? moment(this.props.termsStore.terms.updated).format("DD.MM.YYYY / HH:mm") : 'Nie'}
                                onChange={this.handleInputChange}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                disabled
                            />
                        </Grid>
                    </Grid>
                    <Typography variant="subheading" gutterBottom>
                        Inhalte
                    </Typography>
                    <Grid container spacing={16} style={{marginBottom: 10}}>
                        <Grid item xs={12}>
                            <Typography variant="body1" gutterBottom>
                                Deutsch
                            </Typography>
                            <Trumbowyg
                                id='react-trumbowyg-de'
                                data={this.props.termsStore.terms.terms_de || ""}
                                onBlur={this.handleDeHTMLEditorBlur}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="body1" gutterBottom>
                                Englisch
                            </Typography>
                            <Trumbowyg
                                id='react-trumbowyg-en'
                                data={this.props.termsStore.terms.terms_en || ""}
                                onBlur={this.handleEnHTMLEditorBlur}
                            />
                        </Grid>
                    </Grid>
                    <AppBar position="fixed" color="primary" className={classes.appBar}>
                        <Toolbar>
                            <Grid
                                container
                                direction="row"
                                justify="flex-end"
                                alignItems="flex-start">
                                <Grid item>
                                    <Button variant="contained" size="small" color="default" onClick={() => this.toggleModal()}
                                            className={classes.warningButton}>
                                        <DeleteIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                        Löschen
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button variant="contained" size="small" color="secondary" onClick={this.handleSubmit.bind(this)} className={classes.button}
                                            disabled={this.props.termsStore.uploading}>
                                        <SaveIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                        Speichern
                                    </Button>
                                </Grid>
                            </Grid>
                            <div className={classes.grow}/>
                        </Toolbar>
                    </AppBar>
                </form>
            </div>
        );
    }
}

export default withStyles(styles)(observer(TermsDetails));
